var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoWarning124X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_2_exclamationmark",
    transform: "translate(-400.746 -132.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41971",
    "data-name": "Path 41971",
    d: "M409.747,132.036a9,9,0,1,0,9,9A9,9,0,0,0,409.747,132.036Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27063",
    "data-name": "Group 27063",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46766",
    "data-name": "Path 46766",
    d: "M409.741,144.4l-.078,0a1.177,1.177,0,0,0-1.107,1.243c0,.026,0,.052,0,.078a1.176,1.176,0,0,0,1.187,1.167c.033,0,.067,0,.1,0a1.167,1.167,0,0,0,1.084-1.243c0-.041,0-.083,0-.124A1.156,1.156,0,0,0,409.741,144.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46767",
    "data-name": "Path 46767",
    d: "M408.288,136.932a22.512,22.512,0,0,0,.987,5.207c.188.622.753.611.932,0a23.079,23.079,0,0,0,1-5.207C411.206,134.588,408.288,134.6,408.288,136.932Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoWarning124X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_warning1_24x24.e0109e2f0c0dd10fee9650f895362248.svg";